import { Tag } from "antd";
import styled from "styled-components";

const Style = styled.div`
  .ant-tag {
    width: 85px;
    margin-right: 0;
    text-align: center;
  }
`;

export default function ProjectTag({ children = '', color }) {
  return (
    <Style>
      <Tag color={color}>
        {children}
      </Tag>
    </Style>
  )
}
